import styled from 'styled-components'
import { Box } from 'grommet'

export const LoginBox = styled(Box)`
  width: 50vw;
  margin-left: 25vw;
`
